import {createContext, useContext} from 'react';

/**
 * Whether archived nodes are shown. Also drives the archived-state preview on nodes removed in the
 * current edit session. Defaults to false so any render outside the editor hides them.
 */
export const ProcedureRunDesignFlowchartShowArchivedContext = createContext<boolean>(false);

/** Reads whether the flowchart is currently showing archived nodes. */
export function useProcedureRunDesignFlowchartShowArchived(): boolean {
  return useContext(ProcedureRunDesignFlowchartShowArchivedContext);
}
